import React from 'react'

import TimelineTaskV2 from '../TimelineTaskV2'

import { useTaskAPI } from '@SonarCX/providers/TaskAPIProvider'

type MessageTaskProps = {
  id: string
}

const MessageTask: React.FC<MessageTaskProps> = ({ id }) => {
  const { tasks, loadTask } = useTaskAPI()

  const task = React.useMemo(() => {
    return tasks[id]
  }, [tasks, id])

  React.useEffect(() => {
    if (!task) {
      loadTask(id)
    }
  }, [task, loadTask, id])

  if (!task) {
    return null
  }

  return <TimelineTaskV2 task={task} isPeer />
}

export default MessageTask
